import { useEffect, useState } from "react";
import { Session } from "@supabase/supabase-js";
import { useQuery } from "@tanstack/react-query";

import { userApi } from "../api/userApi";
import { supabase } from "../lib/supabase";

export function useUser() {
  const [session, setSession] = useState<Session | null>(null);
  const [authInitialized, setAuthInitialized] = useState<boolean>(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setAuthInitialized(true);
    });
    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        setAuthInitialized(true);
      }
    );

    return () => listener.subscription.unsubscribe();
  }, []);

  const query = useQuery({
    queryKey: ["supabaseUser"],
    queryFn: async () => {
      if (!session?.user) return null;
      return userApi.getById(session.user.id);
    },
    enabled: !!session && authInitialized,
  });

  return { ...query, authInitialized, session };
}
